import React from 'react';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { SettingsPage } from '../features/settings/pages/settingsPage';

const Settings: React.FC = () => {

  return (
    <DashboardLayout>
      <SettingsPage />
    </DashboardLayout>
  );
};

export default Settings;